module.exports = __webpack_public_path__ + "img/精准的个性化推荐能力.fab6185f.png";